import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ErrorTable = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${colors.grey4};
	background-color: white;
	border-radius: 3px;
`;

export const HeaderRow = styled.div`
	display: flex;
	font-size: 16px;
	line-height: 24px;
	padding: 16px 32px;
`;

export const HeaderLabel = styled.div`
	color: ${colors.grey5};
	white-space: nowrap;
	margin-right: 8px;
`;

export const HeaderHelper = styled.div`
	color: ${colors.grey8};
	font-weight: 500;
	letter-spacing: 0.3px;
	white-space: nowrap;
`;

export const HeaderValue = styled(HeaderHelper)`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	margin-right: 5px;
`;

export const FlexAlignRight = styled.div`
	margin-left: auto;
`;

export const FileSummary = styled.div`
	color: white;
	display: flex;
	flex-direction: row;
	padding: 0 32px;
	background-color: ${colors.amber};
	height: 32px;
	align-items: center;
	font-weight: 500;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const ImageWrapper = styled.div`
	margin-right: 8px;
	display: flex;
`;

export const FileList = styled.ul`
	overflow: hidden;
	padding: 16px 32px;
`;

export const FileItem = styled.li`
	color: ${colors.grey5};
	padding: 4px 0;
	font-size: 16px;
	line-height: 24px;
	min-height: 30px;
	display: flex;
	align-items: center;
	word-break: break-word;

	&:last-child {
		border-bottom: none;
	}

	&::before {
		content: '\\2022';
		color: ${colors.grey5};
		font-weight: bold;
		display: inline-block;
		margin-right: 8px;
		font-size: 14px;
		line-height: 24px;
		align-self: flex-start;
	}
`;

export const FileListWrapper = styled.div`
	max-height: 600px;
	overflow: auto;
`;

export const DownloadBtn = styled.button`
	text-transform: uppercase;
	color: white;
	border: none;
	outline: none;
	cursor: pointer;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
`;

export const DownloadContainer = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${colors.grey5};
	cursor: pointer;
`;

export const RadioLabel = styled.div`
	font-size: 14px;
	font-weight: 500;
`;

export const RadioContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const NoteContainer = styled.div`
	font-weight: 500;
`;

export const TableWrapper = styled.div`
	background-color: #ffffff;
	padding: 10px;
`;

export const ActionContainer = styled.div`
	background-color: #ffffff;
	padding: 10px;
	display: flex;
	justify-content: space-between;
`;

export const StepCount = styled.div`
	font-weight: 500;
	font-size: 16px;
`;
